import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/common';
import { AddButtonSuccessMessage } from '../components/AddButtonSuccessMessage.js';
import '@grandvisionhq/elements';

const AddButtonSuccessMessageContainer = ()=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            addedToCart: getLabel('cart.notification.addedToCart')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AddButtonSuccessMessage, {
        caption: labels.addedToCart
    });
};

export { AddButtonSuccessMessageContainer };
//# sourceMappingURL=AddButtonSuccessMessageContainer.js.map
